<div class="main-content">
	<div class="col-md-12">

		<ng-template #customerTypeWidget>
			<div class="ct-wrap" [ngStyle]="ctThemeVars">
				<div class="ct-icon-badge">
					<i class="material-icons">groups</i>
				</div>
				<div class="ct-header">
					<div class="ct-title-group">
						<span class="ct-title">Customer Type Sales</span>
						<span class="ct-subtitle" *ngIf="ctRangeLabel">{{ ctRangeLabel }}</span>
					</div>
					<div class="ct-actions">
						<button class="ct-icon-btn" [class.ct-icon-btn--active]="ctShowRangePicker" (click)="toggleCtRangePicker()" title="Change date range">
							<i class="material-icons">date_range</i>
						</button>
						<button class="ct-icon-btn" [class.ct-icon-btn--active]="ctView === 'table'" (click)="toggleCtView()" [title]="ctView === 'table' ? 'Show chart' : 'Show data'">
							<i class="material-icons">{{ ctView === 'table' ? 'donut_large' : 'table_rows' }}</i>
						</button>
						<button class="ct-icon-btn" (click)="exportCustomerTypeXls()" [disabled]="categoryPieLoading || !customerTypeSlices.length" title="Export Excel">
							<i class="fa fa-file-excel-o"></i>
						</button>
						<button class="ct-icon-btn" (click)="exportCustomerTypePdf()" [disabled]="categoryPieLoading || !customerTypeSlices.length" title="Export PDF">
							<i class="fa fa-file-pdf-o"></i>
						</button>
						<button class="ct-icon-btn" (click)="refreshCustomerType()" [disabled]="categoryPieLoading" title="Refresh">
							<i class="material-icons">refresh</i>
						</button>
					</div>
				</div>
				<div class="ct-range" *ngIf="ctShowRangePicker">
					<button *ngFor="let p of ctDayPresets" class="ct-range-btn" [class.ct-range-btn--active]="!ctCustom && ctDays === p.value" (click)="setCtDays(p.value)">{{ p.label }}</button>
					<button class="ct-range-btn" [class.ct-range-btn--active]="ctCustom" (click)="toggleCtCustom()">
						<i class="material-icons ct-range-btn-icon">date_range</i> Custom
					</button>
					<div class="ct-range-custom" *ngIf="ctCustomOpen">
						<mat-form-field appearance="outline" class="ct-range-date">
							<mat-label>From</mat-label>
							<input matInput [matDatepicker]="ctPickerFrom" [(ngModel)]="ctCustomFrom" [ngModelOptions]="{standalone: true}" (click)="ctPickerFrom.open()" readonly />
							<mat-datepicker-toggle matSuffix [for]="ctPickerFrom"></mat-datepicker-toggle>
							<mat-datepicker #ctPickerFrom></mat-datepicker>
						</mat-form-field>
						<mat-form-field appearance="outline" class="ct-range-date">
							<mat-label>To</mat-label>
							<input matInput [matDatepicker]="ctPickerTo" [(ngModel)]="ctCustomTo" [ngModelOptions]="{standalone: true}" (click)="ctPickerTo.open()" readonly />
							<mat-datepicker-toggle matSuffix [for]="ctPickerTo"></mat-datepicker-toggle>
							<mat-datepicker #ctPickerTo></mat-datepicker>
						</mat-form-field>
						<button class="ct-range-apply" (click)="applyCtCustomRange()" [disabled]="categoryPieLoading || !ctCustomFrom || !ctCustomTo">Apply</button>
					</div>
				</div>
				<div class="ct-stats" *ngIf="customerTypeSlices.length && !categoryPieLoading">
					<div class="ct-stat">
						<span class="ct-stat-val">{{ customerTypeTotal | currency:'CAD':'symbol-narrow':'1.0-0' }}</span>
						<span class="ct-stat-lbl">Total Net</span>
					</div>
					<div class="ct-stat">
						<span class="ct-stat-val">{{ customerTypeUnits | number:'1.0-0' }}</span>
						<span class="ct-stat-lbl">Units</span>
					</div>
					<div class="ct-stat ct-stat--wide">
						<span class="ct-stat-val" [title]="ctDisplayLabel(customerTypeSlices[0]?.label)">{{ ctDisplayLabel(customerTypeSlices[0]?.label) }}</span>
						<span class="ct-stat-lbl">Top Type</span>
					</div>
					<div class="ct-stat">
						<span class="ct-stat-val">{{ customerTypeSlices.length }}</span>
						<span class="ct-stat-lbl">Types</span>
					</div>
				</div>
				<div class="ct-loading" *ngIf="categoryPieLoading">
					<svg class="spinner" width="40" height="40" viewBox="0 0 66 66">
						<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
					</svg>
				</div>
				<div class="ct-body" *ngIf="!categoryPieLoading && customerTypeSlices.length">
					<div class="ct-chart-wrap" [class.d-none]="ctView === 'table'">
						<div class="ct-donut">
							<svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet" class="ct-donut-svg">
								<circle class="ct-donut-track" cx="50" cy="50" r="40" fill="none" stroke-width="14" />
								<g transform="rotate(-90 50 50)">
									<circle *ngFor="let s of customerTypeSlices; let i = index"
											class="ct-donut-slice"
											[class.ct-donut-slice--dim]="hoveredCustomerTypeSlice !== null && hoveredCustomerTypeSlice !== i"
											cx="50" cy="50" r="40" fill="none" stroke-width="14" stroke-linecap="butt"
											[attr.stroke]="s.color"
											[attr.stroke-dasharray]="s.dashLength + ' ' + (CT_DONUT_CIRC - s.dashLength)"
											[attr.stroke-dashoffset]="s.dashOffset"
											(mouseenter)="onCtSliceHover(i)" (mouseleave)="onCtSliceHover(null)" />
								</g>
							</svg>
							<div class="ct-donut-center">
								<ng-container *ngIf="hoveredCustomerTypeSlice === null; else ctHover">
									<span class="ct-donut-center-val">{{ customerTypeTotal | currency:'CAD':'symbol-narrow':'1.0-0' }}</span>
									<span class="ct-donut-center-lbl">Total</span>
								</ng-container>
								<ng-template #ctHover>
									<span class="ct-donut-center-val">{{ (customerTypeSlices[hoveredCustomerTypeSlice!].pct * 100) | number:'1.0-1' }}%</span>
									<span class="ct-donut-center-lbl">{{ ctDisplayLabel(customerTypeSlices[hoveredCustomerTypeSlice!].label) }}</span>
									<span class="ct-donut-center-sub">{{ customerTypeSlices[hoveredCustomerTypeSlice!].value | currency:'CAD':'symbol-narrow':'1.0-0' }}</span>
								</ng-template>
							</div>
						</div>
						<div class="ct-legend">
							<div class="ct-legend-row" *ngFor="let s of customerTypeSlices; let i = index"
								 [class.ct-legend-row--hover]="hoveredCustomerTypeSlice === i"
								 (mouseenter)="onCtSliceHover(i)" (mouseleave)="onCtSliceHover(null)">
								<span class="ct-legend-swatch" [style.background]="s.color"></span>
								<span class="ct-legend-name">{{ ctDisplayLabel(s.label) }}</span>
								<span class="ct-legend-pct">{{ (s.pct * 100) | number:'1.0-1' }}%</span>
								<span class="ct-legend-val">{{ s.value | currency:'CAD':'symbol-narrow':'1.0-0' }}</span>
								<span class="ct-legend-qty">{{ s.qty | number:'1.0-0' }} u</span>
								<span class="ct-legend-bar-wrap">
									<span class="ct-legend-bar" [style.width.%]="s.pct * 100" [style.background]="s.color"></span>
								</span>
							</div>
						</div>
					</div>
					<div class="ct-table-wrap" [class.d-none]="ctView === 'chart'">
						<table class="ct-table">
							<thead>
								<tr>
									<th>Customer Type</th>
									<th class="text-center">Units</th>
									<th class="text-right">Net</th>
									<th class="text-right">Share</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let s of customerTypeSlices">
									<td class="ct-cell-label">
										<span class="ct-legend-swatch" [style.background]="s.color"></span>
										{{ ctDisplayLabel(s.label) }}
									</td>
									<td class="text-center">{{ s.qty | number:'1.0-0' }}</td>
									<td class="text-right ct-cell-total">{{ s.value | currency }}</td>
									<td class="text-right">{{ (s.pct * 100) | number:'1.0-1' }}%</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="ct-empty" *ngIf="!categoryPieLoading && !customerTypeSlices.length">
					No customer-type sales in this period.
				</div>
			</div>
		</ng-template>

		<!-- Items Sold / Items Received — shared by the static layout and the configurable grid -->
		<ng-template #itemsSoldWidget>
			<div class="dcc-wrap" [ngStyle]="itemsSoldThemeVars">
				<div class="dcc-icon-badge">
					<i class="material-icons">shopping_cart</i>
				</div>
				<div class="dcc-chart-header">
					<div class="ct-chart" id="dailySalesChart" style="max-height:300px"></div>
					<div class="ct-chart" *ngIf="!ordersbyday">
						<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</div>
				</div>
				<div class="dcc-body">
					<div class="dcc-actions">
						<button mat-raised-button type="button" class="btn btn-info btn-link" matTooltip="Refresh" [matTooltipPosition]="'below'" (click)="loadData()">
							<i class="material-icons">refresh</i>
						</button>
					</div>
					<h4 class="dcc-title">Items Sold</h4>
				</div>
				<div class="dcc-footer">
					<p class="dcc-stat">
						<span [ngClass]="percentup > 1 ? 'text-success' : 'text-danger'"><i class="fa " [ngClass]="percentup > 1 ? 'fa-long-arrow-up' : 'fa-long-arrow-down'"></i> {{ percentup - 1 | percent }} </span> {{ orderpweek }} Last week / {{ orderweek }} this week
					</p>
				</div>
			</div>
		</ng-template>

		<ng-template #itemsReceivedWidget>
			<div class="dcc-wrap" [ngStyle]="itemsReceivedThemeVars">
				<div class="dcc-icon-badge">
					<i class="material-icons">inventory</i>
				</div>
				<div class="dcc-chart-header">
					<div class="ct-chart" id="websiteViewsChart" style="max-height:300px"></div>
					<div class="ct-chart" *ngIf="!posbyday">
						<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</div>
				</div>
				<div class="dcc-body">
					<div class="dcc-actions">
						<button mat-raised-button type="button" class="btn btn-info btn-link" matTooltip="Refresh" [matTooltipPosition]="'below'" (click)="loadData()">
							<i class="material-icons">refresh</i>
						</button>
					</div>
					<h4 class="dcc-title">Items Received</h4>
				</div>
				<div class="dcc-footer">
					<p class="dcc-stat">
						<span [ngClass]="popercentup > 1 ? 'text-success' : 'text-danger'"><i class="fa " [ngClass]="popercentup > 1 ? 'fa-long-arrow-up' : 'fa-long-arrow-down'"></i> {{ popercentup - 1 | percent }} </span> {{ popweek }} Last week / {{ poweek }} this week
					</p>
				</div>
			</div>
		</ng-template>

		<div class="container-fluid tp-box" [@flipState]="flip">
			<div class="row tp-box__side tp-box__back" [ngClass]="flip != 'inactive' ? '' : 'd-none'">
				<div class="col-12">
				<div class="fb-wrap" [ngStyle]="flipBackThemeVars">
					<div class="fb-icon-badge pointer" (click)="toggleFlip('')" title="Back to dashboard">
						<i class="material-icons">{{ flipBackIcon }}</i>
					</div>
					<div class="fb-header">
						<div class="fb-title-group">
							<button class="fb-back-btn" (click)="toggleFlip('')" title="Back to dashboard">
								<i class="material-icons">arrow_back_ios</i>
								<span>Dashboard</span>
							</button>
							<span class="fb-title">{{ viewing }}</span>
						</div>
					</div>
					<div class="fb-body">
						<ng-container [ngSwitch]="viewing">
							<ng-container *ngSwitchCase="'Needs Bin'">
								<app-need-bin-location></app-need-bin-location>
							</ng-container>
							<ng-container *ngSwitchCase="'Negative Inventory'">
								<app-negative-items></app-negative-items>
							</ng-container>
							<ng-container *ngSwitchCase="'Metal Prices'">
								<app-metal-prices [flip]="'active'" (viewData)="toggleFlipTest($event)"></app-metal-prices>
							</ng-container>
							<ng-container *ngSwitchCase="'Salesman Territory'">
								<app-salesman-territory-report [embedInDashboard]="true"></app-salesman-territory-report>
							</ng-container>
							<ng-container *ngSwitchCase="'Open Orders'">
								<app-open-orders (preorderloaded)="selectItemLookup($event);" (orderloaded)="selectItemLookup($event)" [customerdata]="''" (orderinvoice)="invoiceOrder($event)" [flipfilter]="openOrdersFlipFilter"></app-open-orders>
							</ng-container>
							<ng-container *ngIf="config.env.package == 'beauty'">
								<ng-container *ngSwitchCase="'Gap Report'">
									<app-gapp-report></app-gapp-report>
								</ng-container>
								<ng-container *ngSwitchCase="'Open Quotes'">
									<!-- <app-open-quotes [quoteData]="openquotes"></app-open-quotes> -->
									<app-quote-list (orderloaded)="selectItemLookup($event)"></app-quote-list>
								</ng-container>
							</ng-container>
							<ng-container *ngSwitchCase="'New Items'">
								<app-new-items-report [type]="'dash'" [data]="newitems"></app-new-items-report>
							</ng-container>
						</ng-container>
					</div>
				</div>
			</div>
		</div>


			<div *ngIf="config?.dashboardThisOverLastTopCard" [ngClass]="flip != 'inactive' ? 'd-none' : ''">
				<app-units-this-last [config]="config" [userdata]="userData"></app-units-this-last>
			</div>

			<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">

				<!-- ── Dashboard customizer trigger ── -->
				<div class="col-12 mb-2" *ngIf="config?.dashboard?.configurable">
					<button class="db-customize-btn"
							[class.db-customize-btn--active]="showDashboardPicker"
							(click)="toggleDashboardPicker()"
							[attr.aria-label]="showDashboardPicker ? 'Close dashboard builder' : 'Customize dashboard'"
							[title]="showDashboardPicker ? 'Close builder' : 'Customize dashboard'">
						<i class="material-icons">{{ showDashboardPicker ? 'close' : 'tune' }}</i>
					</button>
				</div>

				<!-- ══════════════════════════════════════════════════════════
				     Visual Grid Builder
				══════════════════════════════════════════════════════════ -->
				<div class="col-12" *ngIf="config?.dashboard?.configurable && showDashboardPicker">
					<div class="db-builder-panel">

						<!-- Header -->
						<div class="db-builder-header">
							<i class="material-icons db-builder-header__icon">dashboard_customize</i>
							<div class="flex-grow-1">
								<div class="db-builder-header__title">Dashboard Layout Builder</div>
								<div class="db-builder-header__sub">Drag widgets between rows · resize columns · drag from the palette to add · auto-saves</div>
							</div>
							<button class="db-reset-btn" (click)="resetDashboardToDefaults()"
								matTooltip="Reset to default layout — restores all widgets">
								<i class="material-icons">refresh</i> Reset to Defaults
							</button>
						</div>

						<!-- ── Palette: always visible — drag from here to add, drag back to remove ── -->
						<div class="db-palette-wrap">
							<div class="db-palette-label">
								<i class="material-icons">add_circle_outline</i>
								Available Widgets
								<span class="db-palette-hint" *ngIf="builderPalette.length === 0">— drag a widget here from a row to remove it</span>
							</div>
							<div class="db-palette"
								cdkDropList
								id="db-palette"
								cdkDropListOrientation="horizontal"
								[cdkDropListData]="builderPalette"
								[cdkDropListConnectedTo]="allBuilderListIds"
								(cdkDropListDropped)="onBuilderDrop($event)"
								[class.db-palette--empty]="builderPalette.length === 0">
								<div class="db-palette-chip" cdkDrag [cdkDragData]="w"
									*ngFor="let w of builderPalette; trackBy: trackByWidgetKey">
									<div *cdkDragPlaceholder class="db-chip-placeholder"></div>
									<div class="db-chip-icon db-chip-icon--{{ getWidgetColorClass(w.key) }}">
										<i class="material-icons">{{ getWidgetIcon(w.key) }}</i>
									</div>
									<span>{{ getWidgetLabel(w.key) }}</span>
									<i class="material-icons db-chip-drag">drag_indicator</i>
								</div>
								<div class="db-palette-empty-hint" *ngIf="builderPalette.length === 0">
									<i class="material-icons">south</i> Drop here to remove from dashboard
								</div>
							</div>
						</div>

						<!-- ── Grid canvas: one cdkDropList per row ── -->
						<div class="db-canvas">

							<div class="db-grid-row" *ngFor="let row of builderRows; let ri = index; trackBy: trackByRowIndex">

								<!-- Row label -->
								<div class="db-row-label">
									<span class="db-row-badge">Row {{ ri + 1 }}</span>
									<div class="db-row-width-used">
										<div class="db-row-bar" [style.width.%]="rowTotalWidth(row) / 12 * 100"
											[class.db-row-bar--full]="rowTotalWidth(row) >= 12"></div>
									</div>
									<button class="db-row-move" (click)="moveBuilderRow(ri, -1)"
										[disabled]="ri === 0"
										matTooltip="Move row up">
										<i class="material-icons">arrow_upward</i>
									</button>
									<button class="db-row-move" (click)="moveBuilderRow(ri, 1)"
										[disabled]="ri === builderRows.length - 1"
										matTooltip="Move row down">
										<i class="material-icons">arrow_downward</i>
									</button>
									<button class="db-row-delete" (click)="removeBuilderRow(ri)"
										[disabled]="builderRows.length === 1 && row.length === 0"
										matTooltip="Remove row">
										<i class="material-icons">delete_outline</i>
									</button>
								</div>

								<!-- Horizontal drop list -->
								<div class="db-row-list"
									cdkDropList
									[id]="'db-row-' + ri"
									cdkDropListOrientation="horizontal"
									[cdkDropListData]="row"
									[cdkDropListConnectedTo]="allBuilderListIds"
									(cdkDropListDropped)="onBuilderDrop($event)">

									<div class="db-widget-block" cdkDrag [cdkDragData]="w"
										*ngFor="let w of row; let wi = index; trackBy: trackByWidgetKey"
										[style.flex]="w.width + ' 0 ' + (w.width / 12 * 100) + '%'"
										[style.minWidth]="(w.width / 12 * 100) + '%'"
										[style.maxWidth]="(w.width / 12 * 100) + '%'">

										<div *cdkDragPlaceholder class="db-block-placeholder"
											[style.minWidth]="(w.width / 12 * 100) + '%'"></div>

										<!-- Floating ✕ remove badge — always visible, top-right corner -->
										<button class="db-block__x" (click)="removeWidgetFromRow(ri, wi)" title="Remove from dashboard">✕</button>

										<!-- Block header = drag handle -->
										<div class="db-block__head db-block__head--{{ getWidgetColorClass(w.key) }}" cdkDragHandle>
											<i class="material-icons db-block__icon">{{ getWidgetIcon(w.key) }}</i>
											<i class="material-icons db-block__grip">drag_indicator</i>
										</div>

										<!-- Block name -->
										<div class="db-block__name">{{ getWidgetLabel(w.key) }}</div>

										<!-- Width selector -->
										<div class="db-block__widths">
											<button [class.on]="w.width===3"  (click)="setBuilderWidgetWidth(ri,wi,3)"  matTooltip="4/row">¼</button>
											<button [class.on]="w.width===4"  (click)="setBuilderWidgetWidth(ri,wi,4)"  matTooltip="3/row">⅓</button>
											<button [class.on]="w.width===6"  (click)="setBuilderWidgetWidth(ri,wi,6)"  matTooltip="2/row">½</button>
											<button [class.on]="w.width===12" (click)="setBuilderWidgetWidth(ri,wi,12)" matTooltip="Full">■</button>
										</div>

									</div>

									<!-- Empty row hint -->
									<div class="db-row-empty" *ngIf="row.length === 0">
										<i class="material-icons">drag_indicator</i> Drop widgets here
									</div>

								</div>
							</div>

							<!-- Add row — also acts as a drop zone to create a new row with the dropped widget -->
							<div class="db-add-row-dropzone"
								cdkDropList
								id="db-new-row"
								cdkDropListOrientation="horizontal"
								[cdkDropListData]="newRowBuffer"
								[cdkDropListConnectedTo]="allBuilderListIds"
								(cdkDropListDropped)="onDropToNewRow($event)">
								<button class="db-add-row-btn" (click)="addBuilderRow()">
									<i class="material-icons">add</i> Add Row
								</button>
								<span class="db-add-row-hint">or drop a widget here</span>
							</div>

						</div><!-- /db-canvas -->

					</div>
				</div>

				<!-- Configurable dashboards render these as orderable widgets in the grid above.
				     Only the static (non-configurable) layout renders them hardcoded here. -->
				<div class="col-12" *ngIf="userData?.user?.issalesman && config?.dashboardSalesmanKpis && !config?.dashboard?.configurable">
					<app-salesman-kpis></app-salesman-kpis>
				</div>

				<div class="col-12" *ngIf="userData?.user?.issalesman && config?.dashboardSalesmanTerritory && !config?.dashboard?.configurable">
					<app-salesman-territory-stats (viewData)="toggleFlip($event)"></app-salesman-territory-stats>
				</div>

				<div class="col-12" *ngIf="userData.user.issalesman">
					<app-openorders-and-invoices></app-openorders-and-invoices>
				</div>

				<div class="col-6" *ngIf="userData.user.issalesman && config?.dashboardSalesmanScoreboard">
					<app-salesman-scoreboard  [userdata]="userData" [config]="config" ></app-salesman-scoreboard>
				</div>

				<ng-container *ngIf="userData?.user?.issalesman && config?.dashboardSalesmanTopCustomers && !config?.dashboard?.configurable">
					<div
						*ngIf="config?.dashboardSalesmanTopCustomers"
						[ngClass]="salesmanTopCustomersWrapperColClass()"
						class="salesman-top-widgets__cell">
						<app-top-customers [limit]="config.dashboardSalesmanTopCustomersLimit ?? 100" (viewData)="onSalesmanTopCustomersFlip($event)"></app-top-customers>
					</div>
				</ng-container>

				<div *ngIf="config.env.client != 'hairlines' && !config?.dashboard?.configurable" class="dashboard-stat-col" [ngClass]="config.env.package == 'tires' ? 'col-lg-4 col-md-4 col-sm-4' : config.env.package == 'beauty' && !userData.user.issalesman && !isPosUser ? 'col-lg-4 col-md-4 col-sm-4' : 'col-lg-6 col-md-6 col-sm-6'">
					<app-dashboard-stat-card
						title="Open Orders"
						icon="info_outline"
						accent="danger"
						[value]="openorders"
						[loading]="openorders === 'notready'"
						[buckets]="openOrdersAgeBuckets"
						(view)="toggleFlip('Open Orders')"
						(bucketSelect)="toggleFlipOpenOrdersBucket($event)">
					</app-dashboard-stat-card>
				</div>

				<div *ngIf="config.env.client == 'hairlines' && !config?.dashboard?.configurable" class="dashboard-stat-col" [ngClass]="!userData.user.issalesman && !isPosUser ? 'col-lg-4 col-md-4 col-sm-4' : userData.user.issalesman ? 'col-lg-12 col-md-12 col-sm-12' : 'col-lg-6 col-md-6 col-sm-6'">
					<app-dashboard-stat-card
						title="Open Orders"
						icon="info_outline"
						accent="danger"
						[value]="openorders"
						[loading]="openorders === 'notready'"
						[buckets]="openOrdersAgeBuckets"
						(view)="toggleFlip('Open Orders')"
						(bucketSelect)="toggleFlipOpenOrdersBucket($event)">
					</app-dashboard-stat-card>
				</div>

				<div class="dashboard-stat-col col-lg-6 col-md-6 col-sm-6" *ngIf="!config?.dashboard?.configurable && (config.env.package == 'beauty' && config.env.client !='hairlines' && (userData.user.issalesman || isPosUser) || config.env.package == 'beauty' && config.env.client =='hairlines' && (isPosUser))">
					<app-dashboard-stat-card
						title="Open Quotes"
						icon="view_quilt"
						accent="primary"
						[value]="openquotes"
						[loading]="openquotes === 'notready'"
						(view)="toggleFlip('Open Quotes')">
					</app-dashboard-stat-card>
				</div>




				<div class="dashboard-stat-col" [ngClass]="config.env.package == 'tires' ? 'col-lg-4 col-md-4 col-sm-4' : 'col-lg-4 col-md-4 col-sm-4'" *ngIf="((config.env.package == 'beauty' && !userData.user.issalesman && !isPosUser) || config.env.package == 'tires') && !config?.dashboard?.configurable">
					<app-dashboard-stat-card
						title="Need Bin Location"
						icon="store"
						accent="warning"
						[value]="needlocationCount"
						[loading]="needlocation === 'notready'"
						(view)="toggleFlip('Needs Bin')">
					</app-dashboard-stat-card>
				</div>
				<div class="dashboard-stat-col" [ngClass]="config.env.package == 'tires' || this.userData.user.issalesman ? 'col-lg-4 col-md-4 col-sm-4' : 'col-lg-4 col-md-4 col-sm-4'" *ngIf="((config.env.package == 'beauty' && !userData.user.issalesman && !isPosUser) || config.env.package == 'tires') && !config?.dashboard?.configurable">
					<app-dashboard-stat-card
						title="Negative Items"
						icon="content_copy"
						accent="success"
						[value]="negativestock"
						[loading]="negativestock === 'notready'"
						(view)="toggleFlip('Negative Inventory')">
					</app-dashboard-stat-card>
				</div>

				<div class="dashboard-stat-col" [ngClass]="{
					'col-lg-6 col-md-6 col-sm-6': !isPosUser && userData.user.issalesman,
					'col-lg-12 col-md-12 col-sm-12': isPosUser || !userData.user.issalesman
					}"
				*ngIf="!config?.dashboard?.configurable">
					<app-dashboard-stat-card
						title="New Items"
						icon="fiber_new"
						accent="info"
						[value]="newitemsCount"
						[loading]="newitems === 'notready'"
						(view)="toggleFlip('New Items')">
					</app-dashboard-stat-card>
				</div>

				<!-- Metal Prices Widget -->
				<div class="col-12" *ngIf="metalPricesAllowed">
					<app-metal-prices [flip]="flip == 'active' && viewing == 'Metal Prices' ? 'active' : 'inactive'" (viewData)="toggleFlipTest($event)"></app-metal-prices>
				</div>

				<!-- Top Customers — POS users get their location's top customers (salesmen get it above) -->
				<div class="col-12 dashboard-stat-col" *ngIf="isPosUser && !userData.user.issalesman && !config?.dashboard?.configurable">
					<app-top-customers [limit]="config.dashboardSalesmanTopCustomersLimit ?? 100" (viewData)="onSalesmanTopCustomersFlip($event)"></app-top-customers>
				</div>

				<!-- NO PURCHASE -->

				<!-- No static col-md-6: it stayed on the element alongside the ngClass
				     col-md-12, leaving the expanded state to Bootstrap's rule order. -->
				<div class="dashboard-stat-col" [ngClass]="viewing ==='newcustomer' ? 'col-md-12' : 'col-md-6'" *ngIf="!config?.dashboard?.configurable">
					<app-new-customers (viewData)="toggleFlipTest($event)" ></app-new-customers>
				</div>
				<div class="dashboard-stat-col" [ngClass]="viewing ==='nopurch' ? 'col-md-12' : 'col-md-6'" *ngIf="!config?.dashboard?.configurable">
					<app-customer-no-purchase (viewData)="toggleFlipTest($event)"></app-customer-no-purchase>
				</div>


				<!-- Static layout only — in configurable mode these render as orderable widgets (see *ngFor below) -->
				<div class="col-md-6" *ngIf="config.env.package == 'tires' && !config?.dashboard?.configurable">
					<ng-container *ngTemplateOutlet="itemsSoldWidget"></ng-container>
				</div>
				<div class="col-md-6" *ngIf="config.env.package == 'tires' && !config?.dashboard?.configurable">
					<ng-container *ngTemplateOutlet="itemsReceivedWidget"></ng-container>
				</div>



				<!-- BEAUTY TELEGRAM REPORTING -->
				<!-- <div class="col-md-12">
					<app-telegram-reports></app-telegram-reports>
				</div> -->
				<!-- BEAUTY TELEGRAM REPORTING -->
				<!-- <div class="col-md-12" *ngIf="telegramAllowed">
					<app-telegram-reports [menuapp]="false"></app-telegram-reports>
				</div> -->

				<!-- ═══ CONFIGURABLE WIDGET SECTION — rendered in user-saved order ═══ -->
				<ng-container *ngIf="config?.dashboard?.configurable">
					<ng-container *ngFor="let widget of widgetOrder">
						<ng-container *ngIf="isWidgetVisible(widget.key)" [ngSwitch]="widget.key">

							<!-- brand-report -->
							<div [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'brand-report'">
								<app-brand-report [customer]="false" *ngIf="brandAllowed"></app-brand-report>
							</div>

							<!-- line-pie -->
							<div [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'line-pie'" [class.d-none]="!linePie">
								<app-category-and-lines fixedMode="line" accentKey="danger"></app-category-and-lines>
							</div>

							<!-- category-pie -->
							<div [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'category-pie'">
								<app-category-and-lines fixedMode="category" accentKey="info"></app-category-and-lines>
							</div>

							<!-- customer-type-pie -->
							<div [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'customer-type-pie'" [class.d-none]="!customerTypePie">
								<ng-container *ngTemplateOutlet="customerTypeWidget"></ng-container>
							</div>

							<!-- open-orders -->
							<div class="dashboard-stat-col" [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'open-orders'">
								<app-dashboard-stat-card
									title="Open Orders"
									icon="info_outline"
									accent="danger"
									[value]="openorders"
									[loading]="openorders === 'notready'"
									[buckets]="openOrdersAgeBuckets"
									(view)="toggleFlip('Open Orders')"
									(bucketSelect)="toggleFlipOpenOrdersBucket($event)">
								</app-dashboard-stat-card>
							</div>

							<!-- needs-bin -->
							<div class="dashboard-stat-col" [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'needs-bin'">
								<app-dashboard-stat-card
									title="Need Bin Location"
									icon="store"
									accent="warning"
									[value]="needlocationCount"
									[loading]="needlocation === 'notready'"
									(view)="toggleFlip('Needs Bin')">
								</app-dashboard-stat-card>
							</div>

							<!-- negative-items -->
							<div class="dashboard-stat-col" [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'negative-items'">
								<app-dashboard-stat-card
									title="Negative Items"
									icon="content_copy"
									accent="success"
									[value]="negativestock"
									[loading]="negativestock === 'notready'"
									(view)="toggleFlip('Negative Inventory')">
								</app-dashboard-stat-card>
							</div>

							<!-- new-items -->
							<div class="dashboard-stat-col" [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'new-items'">
								<app-dashboard-stat-card
									title="New Items"
									icon="fiber_new"
									accent="info"
									[value]="newitemsCount"
									[loading]="newitems === 'notready'"
									(view)="toggleFlip('New Items')">
								</app-dashboard-stat-card>
							</div>

							<!-- open-quotes -->
							<div class="dashboard-stat-col" [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'open-quotes'">
								<app-dashboard-stat-card
									title="Open Quotes"
									icon="request_quote"
									accent="primary"
									[value]="openquotes"
									[loading]="openquotes === 'notready'"
									(view)="toggleFlip('Open Quotes')">
								</app-dashboard-stat-card>
							</div>

							<!-- gap-report -->
							<div class="dashboard-stat-col" [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'gap-report'">
								<app-dashboard-stat-card
									title="Gap Report"
									icon="view_quilt"
									accent="primary"
									(view)="toggleFlip('Gap Report')">
								</app-dashboard-stat-card>
							</div>

							<!-- new-customers -->
							<div class="dashboard-stat-col" [ngClass]="'col-md-' + widgetColWidth(widget)" *ngSwitchCase="'new-customers'">
								<app-new-customers (viewData)="onWidgetView($event, widget.key)"></app-new-customers>
							</div>

							<!-- no-purchase -->
							<div class="dashboard-stat-col" [ngClass]="'col-md-' + widgetColWidth(widget)" *ngSwitchCase="'no-purchase'">
								<app-customer-no-purchase (viewData)="onWidgetView($event, widget.key)"></app-customer-no-purchase>
							</div>

							<!-- open-credits -->
							<div [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'open-credits'">
								<app-open-credits></app-open-credits>
							</div>

							<!-- open-purchase-orders -->
							<div [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'open-purchase-orders'">
								<app-open-purchase-orders></app-open-purchase-orders>
							</div>

							<!-- canceled-orders -->
							<div [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'canceled-orders'">
								<app-canceled-orders></app-canceled-orders>
							</div>

							<!-- trending-products -->
							<div [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'trending-products'">
								<app-trending-products></app-trending-products>
							</div>

							<!-- top-customers -->
							<div [ngClass]="'col-md-' + widgetColWidth(widget)" *ngSwitchCase="'top-customers'">
								<app-top-customers [limit]="config.dashboardSalesmanTopCustomersLimit ?? 100" (viewData)="onSalesmanTopCustomersFlip($event); onWidgetView($event, widget.key)"></app-top-customers>
							</div>

							<!-- sales-table -->
							<div [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'sales-table'">
								<app-units-this-last [config]="config" [userdata]="userData"></app-units-this-last>
							</div>

						<!-- day-sales -->
							<div [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'day-sales'">
								<app-sales-calendar></app-sales-calendar>
							</div>

						<!-- items-sold: tires daily-sales chart card -->
							<div [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'items-sold'" [class.d-none]="config.env.package != 'tires'">
								<ng-container *ngTemplateOutlet="itemsSoldWidget"></ng-container>
							</div>

						<!-- items-received: tires items-received chart card -->
							<div [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'items-received'" [class.d-none]="config.env.package != 'tires'">
								<ng-container *ngTemplateOutlet="itemsReceivedWidget"></ng-container>
							</div>

						<!-- salesman-territory: team leaderboard for sales managers -->
							<div [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'salesman-territory'">
								<app-team-leaderboard *ngIf="canViewLeaderboard"></app-team-leaderboard>
							</div>

						<!-- salesman-kpis: Sales Performance card (reps only) -->
							<div [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'salesman-kpis'">
								<app-salesman-kpis *ngIf="userData?.user?.issalesman && config?.dashboardSalesmanKpis"></app-salesman-kpis>
							</div>

						<!-- salesman-stats: Territory Sales Stats card (reps only) -->
							<div [ngClass]="'col-md-' + widget.width" *ngSwitchCase="'salesman-stats'">
								<app-salesman-territory-stats *ngIf="userData?.user?.issalesman && config?.dashboardSalesmanTerritory" (viewData)="toggleFlip($event)"></app-salesman-territory-stats>
							</div>

						</ng-container>
					</ng-container>
				</ng-container>
				<!-- ═══ END CONFIGURABLE WIDGET SECTION ═══ -->

				<!-- ═══ STATIC FALLBACK — only renders for non-configurable clients ═══ -->
				<ng-container *ngIf="!config?.dashboard?.configurable">
				<div class="col-md-12" *ngIf="brandAllowed">
					<app-brand-report [customer]="false"></app-brand-report>
				</div>
				<div class="col-md-6" *ngIf="linePie">
					<app-category-and-lines fixedMode="line" accentKey="danger"></app-category-and-lines>
				</div>
				<div class="col-md-6">
					<app-category-and-lines fixedMode="category" accentKey="info"></app-category-and-lines>
				</div>

				<div class="col-md-12" *ngIf="customerTypePie">
					<ng-container *ngTemplateOutlet="customerTypeWidget"></ng-container>
				</div>
				<!-- day-sales: calendar with day → brand → salons drill (config-grid has this too) -->
				<div class="col-md-12" *ngIf="staticSalesCalendarAllowed">
					<app-sales-calendar></app-sales-calendar>
				</div>
				</ng-container>
				<!-- ═══ END STATIC FALLBACK ═══ -->

				<!-- NO PURCHASE
				<div class="col-md-6">
					<app-customer-no-purchase></app-customer-no-purchase>
				</div>
				*ngIf="config.env.package == 'tires'"
				-->
				<div class="col-md-12" *ngIf="!config?.dashboard?.configurable">
					<app-units-this-last [config]="config" [userdata]="userData"></app-units-this-last>
				</div>
			</div>
		</div>
	</div>
</div>